<template>
    <div v-if="active">
        <div>
            <div
                v-if="showLabel"
                v-html="`È possibile inserire un solo coupon per ordine`"
            />
            <form
                @submit.prevent="addCoupon(coupon)"
                v-if="!orderHasCoupon"
            >
                <br>
                <div class="flex coupon-section" :class="{'ma-auto': centered}">
                    <input
                        type='text'
                        class='form-control'
                        placeholder='Codice'
                        v-model="coupon"
                    >

                     <CTA
                        type="submit"
                        :content="$t('buttons.apply')"
                        :size="`small`"
                        :loading="loading"
                    />
                </div>
            </form>

            <form
                @submit.prevent="removeCoupon(coupon)"
                v-if="orderHasCoupon"
                :class="{'ma-auto': centered}"
            >
                <div
                    v-if="showLabel"
                    class="label"
                    v-html="`Hai un coupon di € ${ order.discount.group[0].amount } applicato da utilizzare ${ order.discount.group[0].coupon.tags === 'extra' ? 'sullo shop' : 'sulle ricette'}.`"
                />
                    
                <br>
                <div
                    class="flex coupon-section"
                    :class="{'ma-auto': centered}"
                >
                    <input
                        type='text'
                        class='form-control'
                        v-model="coupon"
                        disabled
                    >

                    <CTA
                        type="submit"
                        v-if="couponIsRemovable"
                        :content="`Rimuovi`"
                        :size="`small`"
                        :loading="loading"
                    />
                   
                </div>
            </form>

            <flash
                v-if="orderGetError !== false"
                :flash="orderGetError"
                state="error"
            />

            <flash
                v-else-if="orderHasCoupon"
                :flash="orderGetCoupon"
                state="success text-bold"
            />

            <flash
                :flash="errorStore.message"
                :state="state"
            />

            <div
                v-if="orderHasCoupon && !couponIsRemovable"
                v-html="`Sarà possibile inserire un nuovo coupon al termine della promozione in corso`"
            />

            <slot
                name="label"
            />

            <br>
        </div>

    </div>
</template>

<script>
import { OrderApi } from '../../api/OrderApi'
import { Order } from '../../core/Order'
import { orderStore } from '../../store/orderStore'
import { errorStore } from '../../store/errorStore'
import { prices } from '../../mixins/prices'
import { orderAction } from '../../mixins/orderAction'
import Flash from '../Parts/Flash'

export default {
    data () {
        return {
            active: this.openedOnLoad,
            orderStore: orderStore.state,
            errorStore: errorStore.state,
            loading: false,
            state: null,
            raw: null
        }
    },

    mixins: [
        prices,
        orderAction
    ],

    components: {
        Flash
    },

    props: {
        redirect: {
            type: Boolean,
            default: false
        },
        centered: {
            type: Boolean,
            default: false
        },
        openedOnLoad: {
            type: Boolean,
            default: true
        },
        showLabel: {
            type: Boolean,
            default: true
        }
    },

    computed: {


        coupon: {
            get: function () {
                if (this.orderHasCoupon) {
                    return this.order.discount.group[0].coupon.code
                } else {
                    return this.raw
                }
            },
            set: function (t) {
                this.raw = t
            }
        },

        user () {
            return this.$root.$data.user
        },

        order () {
            return this.user.order
        },
    
        orderToken () {
            if (!this.order) return
            return this.order.token
        },
        orderHasCoupon () {
            return this.order && this.order.discount && this.order.discount.group && this.order.discount.group.length > 0 && this.order.discount.group[0] && this.order.discount.group[0].coupon
        },

        orderGetCoupon () {
            let couponDuration = this.order.discount.group[0].coupon.weeks
            let text = 'Il tuo coupon è valido per un totale di ' + couponDuration.toString() + ' ordini!'
            return this.orderHasCoupon ? text : false
        },

        orderGetError () {
            return (this.order && this.order.errors.discount && this.order.errors.discount.length > 0) ? errorStore.formatKeyMessage(this.order.errors.discount[0]) : false
        },

        couponIsRemovable () {
            if (!this.orderHasCoupon) return
            return this.order.discount.group[0].coupon.removable
        }
    },

    methods: {

        toggle () {
            errorStore.removeMessage()
            this.active = !this.active
        },

        removeCoupon (coupon) {
            errorStore.removeMessage()

            if (this.loading) {
                return;
            }

            if (!coupon) return
            if (!this.orderToken) return

            this.loading = true;

            var params = {
                coupon_code: coupon
            }

            var om = new OrderApi()
            return om.removeCoupon(this.orderToken, params)

            .then(response => {
                return this.success(response)
            })

            .catch(response => {
                errorStore.formatMessage(response)
                this.state = 'error'
            })

            .finally(response => {
                this.loading = false
            })
        },

        addCoupon (coupon) {
            errorStore.removeMessage()

            if (this.loading) {
                return;
            }


            if (!coupon) return
            if (!this.orderToken) return


            this.loading = true;

            var params = {
                coupon_code: coupon
            }

            var om = new OrderApi()
            return om.addCoupon(this.orderToken, params)

            .then(response => {
                // errorStore.updateMessage('Codice applicato')
                return this.success(response)
            })

            .catch(response => {
                errorStore.formatMessage(response)
                this.state = 'error'
            })

            .finally(response => {
                this.loading = false
            })
        },

        success (response) {
            return this.$_orderAction_updateCurrentRecipes(0).then(i => {

                this.state = 'success'
                if (this.redirect && user.order.payment && user.order.payment.status == 'requires_action') {
                    this.$emit('refresh');
                }
            });

        }
    },
}

</script>

<style scoped>
.label {
    font-weight: bold;
}

.coupon-section {
    max-width: 205px;
}
</style>
